import React from "react";
import "../styles/previewFooter.css";

export default function PreviewFooter() {
  return (
    <div className="cta-footer">
      <h2 className="cta-title">Ready to Build Your Perfect Website?</h2>
      <p className="cta-subtext">
        Sign up now and let’s bring your vision to life
      </p>
      <a
        href="https://www.networksolutions.com/website/diy-website-builder?brand=web&siteID=100&channelID=P99C100S653N0B5A1D0E0000V100"
        target="_blank"
        rel="noopener noreferrer"
        className="cta-button"
      >
        Sign Up Now to Keep Building
      </a>
    </div>
  );
}
